module.exports = __webpack_public_path__ + "img/ccwa.47d8e29.png";